/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStack2 = createReactComponent("stack-2", "IconStack2", [
  ["path", { d: "M12 4l-8 4l8 4l8 -4l-8 -4", key: "svg-0" }],
  ["path", { d: "M4 12l8 4l8 -4", key: "svg-1" }],
  ["path", { d: "M4 16l8 4l8 -4", key: "svg-2" }]
]);

export { IconStack2 as default };
//# sourceMappingURL=IconStack2.js.map
